import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { TallerDetail } from "./TallerDetail";
import Loader from "../Loader";
import { CartContext } from "../../context/CartContext";

const TallerDetailContent = () => {
  // Al entrar, siempre arriba
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [itemDetail, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { idProducto } = useParams();
  const { items } = useContext(CartContext);

  useEffect(() => {
    // Buscamos forzando a String para que coincidan siempre
    const foundItem = items.find(
      (item) => String(item.id) === String(idProducto),
    );

    if (foundItem) {
      // Pasamos el item encontrado al estado
      setItem(foundItem);
    }
    setIsLoading(false);
  }, [idProducto, items]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : itemDetail ? (
        <div className="detalleTaller">
          <TallerDetail itemDetail={itemDetail} />
        </div>
      ) : (
        <div className="text-center mt-5">
          <h3>Taller no encontrado</h3>
        </div>
      )}
    </>
  );
};

export default TallerDetailContent;
